import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';

import * as Objects from '@core/objects'
import * as CFormsSearch from '@core/custom-forms/models/field-search.model';

interface SearchAvailableStatusFilters extends CFormsSearch.SearchAvailableFilters {
    items: Array<Objects.Status>;
}
@Component({
    selector: 'core-custom-forms-helpers-search-filters-status-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class CustomFormsHelpersSearchFiltersStatusMainComponent implements OnInit{

    @Input()  available: SearchAvailableStatusFilters = null;
    @Input()  applied: Array<CFormsSearch.SearchAppliedFilter> = [];

    @Output() apply = new EventEmitter<CFormsSearch.SearchAppliedFilter>();
    
    public status: Objects.Status[] = [];

    ngOnInit(): void {
        this.makeStatus();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.applied)
            this.makeStatus();
    }

    private isApplied(status: Objects.Status) : boolean {
        return this.applied.some((f: CFormsSearch.SearchAppliedFilter) => f.key == this.available.key && f.identifier == status.id);
    }

    private makeStatus() {
        this.status = this.available.items.filter((status: Objects.Status) => !this.isApplied(status));
    }

    onSelect(status: Objects.Status) {
        this.apply.emit({key: this.available.key,identifier: status.id});
    }

}
